import React__default, { useMemo } from 'react';
import { useId, Box, SelectionSet, ColorSwatches, SelectionSetInput, SelectionSetLabel, ColorSwatch } from '@vp/swan';
import { SimpleTitle } from '../../../../shared/simple-title/simple-title.mjs';

const StandardColorSwatchButtonSkin = (props) => {
    return React__default.createElement(ColorSwatchButtonSkin, { ...props, size: "standard" });
};
const WideColorSwatchButtonSkin = (props) => {
    return React__default.createElement(ColorSwatchButtonSkin, { ...props, size: "super" });
};
const ColorSwatchButtonSkin = ({ option, size, showIncompatibleChoices, onChanged }) => {
    const [selectedKey, setSelectedKey] = React__default.useState(option.selectedKey ?? null);
    useMemo(() => {
        const choice = option.choices.find((choice) => choice.key === option.selectedKey);
        const choiceDisplayed = choice?.isOutOfStock || choice?.isCompatible || showIncompatibleChoices;
        const choiceDisabled = choice?.isOutOfStock ?? false;
        if (choiceDisplayed && !choiceDisabled) {
            setSelectedKey(option.selectedKey ?? null);
        }
    }, [option, showIncompatibleChoices]);
    const onChangeHandler = (selectedValue) => {
        setSelectedKey(selectedValue);
        onChanged?.({ choiceKey: selectedValue });
    };
    const titleId = useId();
    return (React__default.createElement(Box, null,
        React__default.createElement(SimpleTitle, { titleId: titleId, showSelectedOptionText: true }),
        React__default.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "single-select", selectedValue: selectedKey, onSelectedValueChange: onChangeHandler, "aria-required": option.isRequired, "aria-labelledby": titleId },
            React__default.createElement(ColorSwatches, { className: "color-swatches-base", size: size }, option.choices.map((choice, i) => {
                const primaryAndSecondary = choice.key?.split("/");
                const primaryColor = primaryAndSecondary?.[0];
                const secondaryColor = primaryAndSecondary?.[1] ?? primaryColor;
                const selectorDisplayed = choice.isOutOfStock || choice.isCompatible || showIncompatibleChoices;
                const selectorDisabled = choice.isOutOfStock ?? false;
                return (selectorDisplayed && (React__default.createElement(SelectionSetInput, { key: `choice_${choice.key}`, value: choice.key, disabled: selectorDisabled },
                    React__default.createElement(SelectionSetLabel, null,
                        React__default.createElement(ColorSwatch, { component: "span", primaryColor: primaryColor, secondaryColor: secondaryColor, accessibleText: choice.name })))));
            })))));
};

export { ColorSwatchButtonSkin, StandardColorSwatchButtonSkin, WideColorSwatchButtonSkin };
//# sourceMappingURL=color-swatch-button-skin.mjs.map
